
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iframe/signup",
      function () {
        return require("private-next-pages/iframe/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iframe/signup"])
      });
    }
  